export default "__VITE_ASSET__yZOV9_02__"